<template>
  <div class="table__filters">
    <div class="table__filters__title">
      <v-icon color="gray-6" small>filter_list</v-icon>
      {{ $t('Common.filters') }}
    </div>

    <div class="table__filters__item">
      <FormTextField
        v-model="filters.search"
        :name="$t(`${namespace}.searchByPhone`)"
        :placeholder="$t(`${namespace}.searchByPhone`)"
        :disabled="isLoading"
        :loading="isLoading"
        prepend-icon="search"
        :mask="['(##) ####-####', '(##) #####-####']"
        clearable
        small
        @reset="reset"
      />
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'

export default {
  name: 'TableFilters',
  props: {
    status: {
      type: Number,
      default: STATUS_IS_LOADING
    }
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.SearchPhonePage',
      filters: {
        search: null
      }
    }
  },
  methods: {
    emitChangeEvent () {
      const filters = {
        ...this.filters,
        search: this.filters.search.replace(/\D/g, '')
      }

      this.$emit('change', filters)
    },

    handleSearch: debounce(function () {
      this.emitChangeEvent()
    }, 1000),

    reset () {
      this.filters.search = ''
      this.emitChangeEvent()
    }
  },
  watch: {
    'filters.search' (val) {
      if (!val) {
        this.reset()
        return
      }

      if (typeof val === 'string' && (val.length === 14 || val.length === 15)) {
        this.handleSearch()
      }
    }
  }
}
</script>
